export default __webpack_public_path__ + "static/media/FFP_Notas_as_Contas_2022.61121838.pdf";